import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzNativeDateAdapter } from 'ng-zorro-antd/core/time';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  API_BASE_URL,
  authInterceptor,
  errorInterceptor,
  PORTAL_NAME,
  refreshTokenInterceptor,
} from '@dlap-ui/core';
import { environment } from '../environments/environment';
import {
  AppstoreOutline,
  ArrowRightOutline,
  BankOutline,
  BranchesOutline,
  CalendarOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  CustomerServiceOutline,
  DeleteOutline,
  DollarOutline,
  DownOutline,
  EditOutline,
  EnvironmentOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileProtectOutline,
  FileTextOutline,
  FileDoneOutline,
  FilterOutline,
  HomeOutline,
  IdcardOutline,
  InboxOutline,
  KeyOutline,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  PlayCircleOutline,
  PlusOutline,
  RightOutline,
  SafetyOutline,
  SearchOutline,
  StopOutline,
  TeamOutline,
  ThunderboltOutline,
  UndoOutline,
  UserOutline,
  WalletOutline,
} from '@ant-design/icons-angular/icons';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, refreshTokenInterceptor])),
    provideRouter(appRoutes),
    provideNzI18n(en_US),
    provideNzNativeDateAdapter(),
    NzModalService,
    { provide: API_BASE_URL, useValue: environment.server },
    { provide: PORTAL_NAME, useValue: 'HIGH_COURT' },
    provideNzIcons([
      MailOutline,
      LockOutline,
      KeyOutline,
      EyeOutline,
      EyeInvisibleOutline,
      MenuFoldOutline,
      MenuUnfoldOutline,
      SearchOutline,
      PlusOutline,
      UserOutline,
      DownOutline,
      LoginOutline,
      RightOutline,
      ArrowRightOutline,
      LogoutOutline,
      AppstoreOutline,
      FilterOutline,
      CalendarOutline,
      UndoOutline,
      EditOutline,
      DeleteOutline,
      CloseCircleOutline,
      CheckCircleOutline,
      DollarOutline,
      TeamOutline,
      WalletOutline,
      HomeOutline,
      BankOutline,
      BranchesOutline,
      EnvironmentOutline,
      FileProtectOutline,
      FileTextOutline,
      FileDoneOutline,
      IdcardOutline,
      InboxOutline,
      PlayCircleOutline,
      StopOutline,
      SafetyOutline,
      ThunderboltOutline,
      CustomerServiceOutline,
    ]),
  ],
};
